import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DefaultMeetingService {

  constructor(private http: HttpClient, private httpService: HttpService) { }

  addDefaultMeeting(MeetingData) {
      var request = {
          URL: 'addDefaultMeeting',
          DATA: MeetingData
      }
    return this.httpService.post(request);
  }

  getDefaultMeetingList() {
    var request = {
        URL: 'getDefaultMeeting/'
    }
    return this.httpService.get(request);
  }

  getDefaultMeetingDataById(id) {
    var request = {
        URL: 'getDefaultMeetingListById/'+id
    }
    return this.httpService.get(request);
  }

  checkMeetingTypeExist(meetingIds)
  {
    var request = {
      URL: 'checkMeetingTypeExistInDefaultMeetingMaster',
      DATA: meetingIds
    }
    return this.httpService.post(request);
  }

  updateDefaultMeeting(editMeetingData,DefaultMeetingId) {
    var request = {
        URL: 'updateDefaultMeeting/'+DefaultMeetingId,
        DATA: editMeetingData
    }
  return this.httpService.post(request);
  } 

  deleteDefaultMeetingMasterData(dftMeetId) {
    var request = {
        URL: 'deleteDefaultMeeting/' + dftMeetId,
    }
    return this.httpService.get(request);
  }

  getDefaultMeetingDataByMeetingIdNCompanyId(MeetingId) {
    var request = {
        URL: 'getDefaultMeetingDataByMeetingIdNCompanyId/'+MeetingId
    }
    return this.httpService.get(request);
  }

}
